export default __webpack_public_path__ + "static/media/download-icon.6974ece4.svg";